import { Navigate, Route, Routes } from 'react-router'
import MyVms from './MyVms'
import MyVm from './MyVm'
import MyTeams from './MyTeams'
import MyPage from '../me/MyPage'
import NewSshKey from '../me/NewSshKey'
import SshKeys from '../me/SshKeys'
import CreateVm from '../vm/CreateVm'

// 사용자 화면의 경로. 내 VM 목록·상세와 VM 생성 페이지, 내 팀, 계정 메뉴가 여는 내 정보뿐이고, 그 밖은 목록으로 돌아간다.
// 생성 페이지의 고정 경로는 상세의 `:id` 보다 앞서 맞는다.
export function UserScreens() {
  return (
    <Routes>
      <Route path="/" element={<MyVms />} />
      <Route path="/leases/new" element={<CreateVm />} />
      <Route path="/leases/:id" element={<MyVm />} />
      <Route path="/teams" element={<MyTeams />} />
      <Route path="/me" element={<MyPage />} />
      <Route path="/me/keys" element={<SshKeys />} />
      <Route path="/me/keys/new" element={<NewSshKey />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
